export interface CreateOrderListRequest {
  selectionDate: string
  selectionCount: number | string
  selectionType: string
  displayMemo: string
  selectionReason: string
  traderCode: string
  acceptType: string
  departmentCode: string
  donorCode: string
  budgetYear: number | string
  budgetBranchCode: string
  budgetDepartmentCode: string
  budgetExpenseCode: string
  equipType: string
  collectionType: string
  handlingType: string
  shelfType: string
  orderNumbers: {
    orderBranchCode: string
    orderNumber: number | string
  }[]
  tooliFlag: boolean
  tooliCustomerId: string
  tooliOrderType: string
  materialFormatCode: string
}

export function CreateOrderListRequestToJSON(
  value: CreateOrderListRequest
): any {
  return {
    selection_date:
      value.selectionDate !== '' ? value.selectionDate : undefined,
    selection_count: value.selectionCount ? value.selectionCount : undefined,
    selection_type:
      value.selectionType !== '' ? value.selectionType : undefined,
    display_memo: value.displayMemo !== '' ? value.displayMemo : undefined,
    selection_reason:
      value.selectionReason !== '' ? value.selectionReason : undefined,
    trader_code: value.traderCode !== '' ? value.traderCode : undefined,
    accept_type: value.acceptType !== '' ? value.acceptType : undefined,
    department_code:
      value.departmentCode !== '' ? value.departmentCode : undefined,
    donor_code: value.donorCode !== '' ? value.donorCode : undefined,
    budget_year: value.budgetYear ? value.budgetYear : undefined,
    budget_branch_code:
      value.budgetBranchCode !== '' ? value.budgetBranchCode : undefined,
    budget_department_code:
      value.budgetDepartmentCode !== ''
        ? value.budgetDepartmentCode
        : undefined,
    budget_expense_code:
      value.budgetExpenseCode !== '' ? value.budgetExpenseCode : undefined,
    equip_type: value.equipType !== '' ? value.equipType : undefined,
    collection_type:
      value.collectionType !== '' ? value.collectionType : undefined,
    handling_type: value.handlingType !== '' ? value.handlingType : undefined,
    shelf_type: value.shelfType !== '' ? value.shelfType : undefined,
    order_numbers:
      value.orderNumbers.filter(value => value.orderNumber !== 0).length > 0
        ? value.orderNumbers
            .filter(value => value.orderNumber !== 0)
            .map(value => {
              return {
                order_branch_code:
                  value.orderBranchCode !== ''
                    ? value.orderBranchCode
                    : undefined,
                order_number:
                  value.orderNumber !== 0 ? value.orderNumber : undefined
              }
            })
        : undefined,
    tooli_flag: value.tooliFlag ?? undefined,
    tooli_customer_id:
      value.tooliCustomerId !== '' ? value.tooliCustomerId : undefined,
    tooli_order_type:
      value.tooliOrderType !== '' ? value.tooliOrderType : undefined,
    material_format_code:
      value.materialFormatCode !== '' ? value.materialFormatCode : undefined
  }
}
